import axios from "axios";
import { jwtDecode } from "jwt-decode";

const API_BASE_URL = process.env.REACT_APP_API_URL;

// Create an Axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
});

// Helper functions
const getAccessToken = () => localStorage.getItem("access_token");
const getRefreshToken = () => localStorage.getItem("refresh_token");

const decodeToken = (token) => {
  try {
    return token ? jwtDecode(token) : null;
  } catch (error) {
    console.error("Error decoding token:", error);
    return null;
  }
};

const isTokenExpired = (token) => {
  const decoded = decodeToken(token);
  if (!decoded || !decoded.exp) return true; // Assume expired if decoding fails
  return Date.now() >= decoded.exp * 1000; // Convert exp to milliseconds
};

// Refresh token function
const refreshToken = async () => {
  try {
    const refresh = getRefreshToken();
    if (!refresh) return null;

    const response = await axios.post(`${API_BASE_URL}/token/refresh/`, {
      refresh,
    });

    localStorage.setItem("access_token", response.data.access);
    return response.data.access;
  } catch (error) {
    console.error("Token refresh failed:", error);
    logoutUser();
    return null;
  }
};

// Logout user function
const logoutUser = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  alert("Your session has expired. Please log in again.");
  window.location.href = "/authentication/sign-in";
};

// Axios request interceptor
api.interceptors.request.use(
  async (config) => {
    let token = getAccessToken();

    if (!token || isTokenExpired(token)) {
      console.warn("Access token expired. Trying to refresh...");
      token = await refreshToken();
      if (!token) return Promise.reject(new Error("Session expired"));
    }

    // Attach token to request headers
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error),
);

// Attach token to every request
/*api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});*/

export default api;
